import { create } from 'zustand';
import type { PortalSupplier } from '../api/supplier';

interface SupplierState {
  supplier: PortalSupplier | null;
  token: string | null;
  isAuthenticated: boolean;

  setSession: (supplier: PortalSupplier, token: string) => void;
  setSupplier: (supplier: PortalSupplier) => void;
  logout: () => void;
}

export const useSupplierStore = create<SupplierState>((set) => ({
  supplier: null,
  token: localStorage.getItem('supplierToken'),
  isAuthenticated: !!localStorage.getItem('supplierToken'),

  setSession: (supplier, token) => {
    localStorage.setItem('supplierToken', token);
    set({ supplier, token, isAuthenticated: true });
  },

  setSupplier: (supplier) => set({ supplier }),

  logout: () => {
    localStorage.removeItem('supplierToken');
    set({ supplier: null, token: null, isAuthenticated: false });
  },
}));
